function extractVueFunctions () {
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frontmatter-markdown"},[_c('h2',[_vm._v("Complete funnel analysis at glance")]),_vm._v(" "),_c('p',[_vm._v("From Attention, through Interest and Desire, to Action and beyond - WhiteBox gets you covered. Study your digital marketing performance with confidence!")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Study various digital marketing sale funnels")]),_vm._v(" "),_c('li',[_vm._v("Determine the Return On Advertising Spent")])])])}]

return { render, staticRenderFns }
}
const vueFunctions = extractVueFunctions()

module.exports = { 
      attributes: {"href":"/interactions/crm","interaction":"crm","title":"(Conversion)|funnel","image":"/img/interactions/7.svg"},
    
      vue: {
        component: {
          data: function () {
            return {
              templateRender: null
            }
          },
          render: function (createElement) {
            return this.templateRender ? this.templateRender() : createElement("div", "Rendering");
          },
          created: function () {
            this.templateRender = vueFunctions.render;
            this.$options.staticRenderFns = vueFunctions.staticRenderFns;
          }
        }
      },
     }